/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { useTranslation } from 'react-i18next';
// ui
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
// icons
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LaunchIcon from '@material-ui/icons/Launch';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AvTimerIcon from '@material-ui/icons/AvTimer';

function DialButton(props) {
  const { t } = useTranslation();
  const { classes, speedDialToggle, open, disabledDepartures, toggleForm } = props;

  const actions = [
    { icon: <AvTimerIcon />, name: t('process.equipments'), module: 'processEquipments' },
    { icon: <AddBoxIcon />, name: t('process.supplies'), module: 'supplyProducts' },
    { icon: <PersonAddIcon />, name: t('process.staff'), module: 'staff' },
    { icon: <LaunchIcon />, name: t('process.departures'), module: 'departure', disabled: disabledDepartures },
    { icon: <ExitToAppIcon />, name: t('process.entries'), module: 'entry' },
  ];

  return (
    <ClickAwayListener onClickAway={() => (open ? speedDialToggle() : null)}>
      <SpeedDial
        ariaLabel="process-dial-button"
        icon={<SpeedDialIcon />}
        className={classes.fab}
        onClick={speedDialToggle}
        open={open}
        direction="up">
        {actions
          .filter((action) => !action.disabled)
          .map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              data-module={action.module}
              onClick={toggleForm}
              tooltipOpen
            />
          ))}
      </SpeedDial>
    </ClickAwayListener>
  );
}

export default DialButton;
